import React from 'react';
import CData from './CData';
import TopicCard from './TopicCard';
import Explore from '../Explore';


const CardLogic = () =>{
  return(
    <React.Fragment>
      <section className="card-logic mt-5 card-image">
          <div className="container">
            <h2 className="text-uppercase py-3" style={{fontWeight:'bold'}}>Our Courses at a glance !</h2>
            <div className="row ">
                {
                CData.map((val, index) => {
                    return (
                        <TopicCard 
                        key={index}
                        title={val.title}
                        imgSrc={val.imgSrc}
                        text={val.text}
                        text2={val.text2}
                        />
                    );
                })
              }
            </div>
          </div>
          <Explore />
      </section>
      
    </React.Fragment>
  );
};

export default CardLogic;
